import React, { PropsWithChildren } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from '@emotion/react';
import { CustomTheme, DeepPartial } from './types';
import { getResolvedTheme } from './getResolvedTheme';
import { createMbTheme } from './createMbTheme';
import { mb } from './mbTokens';

export const defaultFontFamily = "'Roboto', 'Heebo', system-ui, sans-serif";
export type PartialCustomTheme = DeepPartial<CustomTheme>;

type SdkThemeProviderProps = {
  remoteThemeOverride?: PartialCustomTheme;
};

export const WidgetThemeProvider: React.FC<PropsWithChildren<SdkThemeProviderProps>> = ({
  children,
  remoteThemeOverride,
}) => {
  const { i18n } = useTranslation();
  const theme = getResolvedTheme(remoteThemeOverride);
  const direction = i18n.dir();
  const createdTheme = createMbTheme(direction, theme);

  return (
    <MuiThemeProvider theme={createdTheme}>
      <GlobalStyles
        styles={{
          // Plain links (no MUI color of their own) are brand green instead of the browser's default blue/purple.
          a: { color: mb.green },
          '.MuiButtonBase-root:focus-visible, a:focus-visible, button:focus-visible, [role="button"]:focus-visible, [tabindex]:not([tabindex="-1"]):focus-visible':
            { outline: `2px solid ${mb.green}`, outlineOffset: 2 },
          'input:focus-visible, textarea:focus-visible, select:focus-visible, .MuiInputBase-input:focus-visible': {
            outline: 'none',
          },
        }}
      />
      <ThemeProvider
        theme={{
          customTheme: theme,
        }}>
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};
